import React from 'react';
import { Card } from '@mts/ui';

function BasicDealsCard({ deals = [], loading = false, error = '' }) {
  const hasDeals = Array.isArray(deals) && deals.length > 0;

  return (
    <div id="DealsCard">
      <Card
        id="DealsCard-Card"
        className="my-[10px] rounded-lg"
        style={{
          backgroundColor: 'var(--card)',
          borderColor: 'var(--border)',
          borderWidth: '1px',
          borderStyle: 'solid',
        }}
      >
      <Card.Header id="DealsCard-CardHeader" className="flex items-start justify-between gap-3">
        <div id="DealsCard-CardHeaderInner">
          <h2 className="text-base font-semibold text-[var(--primary)]">Deals</h2>
          <Card.Title id="DealsCard-CardTitle">
            <span className="sr-only">Current deals</span>
          </Card.Title>
          <Card.Description id="DealsCard-CardDescription">
            <span className="sr-only">Promotions and offers</span>
          </Card.Description>
        </div>
        <Card.Action id="DealsCard-CardAction">
          <div />
        </Card.Action>
      </Card.Header>

      <Card.Content id="DealsCard-CardContent" className="before:content-none after:content-none">
        {loading ? (
          <p className="text-sm text-black/70">Loading deals...</p>
        ) : error ? (
          <p className="text-sm text-black/70">Unable to load deals right now.</p>
        ) : hasDeals ? (
          <div className="space-y-3">
            {deals.map((deal) => (
              <div key={deal.id} className="rounded-lg border p-3" style={{ borderColor: 'var(--ui-input-border)', backgroundColor: 'var(--card)' }}>
                <div className="flex items-start justify-between gap-3">
                  <div className="space-y-1">
                    <p className="text-sm font-semibold text-black">
                      {deal.href ? (
                        <a href={deal.href} className="hover:text-[var(--primary)]">{deal.title}</a>
                      ) : deal.title}
                    </p>
                    <p className="text-sm text-black/75">{deal.description}</p>
                  </div>
                  <span className="shrink-0 rounded-full bg-black px-2 py-1 text-[10px] font-semibold uppercase tracking-[0.06em] text-white">
                    {deal.badge}
                  </span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-sm text-black/70">No active deals right now.</p>
        )}
      </Card.Content>

      <Card.Footer id="DealsCard-CardFooter">
        <div />
      </Card.Footer>
      </Card>
    </div>
  );
}

export default BasicDealsCard;
